import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;

  h1.title {
    font-size: 17px;
    text-transform: uppercase;
    text-align: center;
    letter-spacing: 2px;
  }

  .invest {
    width: 100%;

    h1.description {
      font-size: 26px;
      margin-top: 20px;
      text-align: center;
    }

    span.description {
      font-size: 12px;
      color: #525252;
    }
  }

  .investSuccess {
    @media (max-width: 647px) {
      text-align: center;
    }
    h1.subtitle {
      font-size: 30px;
      font-weight: bold;
    }

    span.description {
      font-size: 14px;
      padding: 10px 0;
    }

    .content {
      .left {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-right: 20px;

        button {
          height: 36px;
          width: fit-content;
          padding: 0 32px;
          @media (max-width: 647px) {
            align-self: center;
            margin-top: 5px;
          }
        }
      }
    }

    .right {
      @media (max-width: 647px) {
        display: none;
      }
    }
  }

  .content {
    display: flex;
    justify-content: center;
    margin: 32px 0;

    .inputGroup {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;

      .currency {
        .currencyInput {
          width: 180px;
          height: 50px;
          border: 1px solid #000;
          border-radius: 8px;

          display: flex;
          align-items: center;
          justify-content: flex-start;

          padding: 16px;
          margin-bottom: 12px;

          span {
            margin-left: 8px;
          }
        }
      }

      .arrow {
        margin: 14px 22px 0 22px;
      }

      .targetCurrency {
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .targetCurrencySelect {
          width: 180px;
          height: 50px;
          border: 1px solid #000;
          border-radius: 8px;

          display: flex;
          align-items: center;

          margin-bottom: 12px;

          .alignIcon {
            margin-left: 16px;
          }
        }

        .currentCashback {
          margin-bottom: 12px;
          font-size: 20px;
          font-weight: bold;
        }
      }

      @media (max-width: 670px) {
        flex-direction: column;
        width: 100%;

        .currency {
          width: 100%;

          .currencyInput {
            width: 100%;
          }
        }

        .targetCurrency {
          width: 100%;

          .targetCurrencySelect {
            width: 100%;
          }
        }

        .arrow {
          margin: 14px auto;
          transform: rotate(90deg);
        }
      }
    }
  }

  button.investButton {
    height: 50px;

    .loading {
      color: #fff;
    }
  }
`;
